import React from "react";
import { makeStyles, Dialog, DialogContent, DialogActions, Typography, Button, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 18,
    width: "min(920px, calc(100vw - 24px))",
    maxWidth: 920,
    margin: 12,
  },
  head: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    padding: theme.spacing(2, 2, 0, 2.5),
  },
  title: { fontWeight: 800, fontSize: "1.25rem", lineHeight: 1.25 },
  desc: { color: theme.palette.text.secondary, marginTop: 6, fontSize: 14, lineHeight: 1.45 },
  content: { padding: theme.spacing(1.5, 2.5, 1) },
  figure: {
    margin: 0,
    borderRadius: 14,
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.type === "dark" ? "#111827" : "#f8fafc",
  },
  image: {
    display: "block",
    width: "100%",
    height: "auto",
  },
  caption: { fontSize: 12, color: theme.palette.text.secondary, padding: "8px 12px 10px" },
  plan: {
    marginTop: 12,
    padding: "10px 12px",
    borderRadius: 12,
    background: theme.palette.type === "dark" ? "rgba(37,99,235,0.16)" : "#eff6ff",
    color: theme.palette.type === "dark" ? "#dbeafe" : "#1e3a8a",
    fontSize: 13,
    lineHeight: 1.45,
    fontWeight: 600,
  },
  steps: { listStyle: "none", margin: "14px 0 0", padding: 0, display: "grid", gap: 10 },
  step: { display: "flex", gap: 12, alignItems: "flex-start" },
  num: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    fontSize: 13,
    color: "#fff",
    background: theme.palette.primary.main,
  },
  stepText: { fontSize: 14, lineHeight: 1.5, paddingTop: 3 },
}));

const GuideFloat = ({ open, title, description, steps, image, imageCaption, planHint, onClose, onOpen, openLabel, closeLabel }) => {
  const classes = useStyles();
  const items = Array.isArray(steps) ? steps : [];
  return (
    <Dialog open={!!open} onClose={onClose} scroll="paper" classes={{ paper: classes.paper }} aria-labelledby="guide-float-title">
      <div className={classes.head}>
        <div>
          <Typography id="guide-float-title" className={classes.title}>{title}</Typography>
          {description ? <Typography className={classes.desc}>{description}</Typography> : null}
        </div>
        <IconButton aria-label={closeLabel || "Cerrar"} onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.content}>
        {image ? (
          <figure className={classes.figure}>
            <img className={classes.image} src={image} alt="" />
            {imageCaption ? <figcaption className={classes.caption}>{imageCaption}</figcaption> : null}
          </figure>
        ) : null}
        {planHint ? <div className={classes.plan}>{planHint}</div> : null}
        <ol className={classes.steps}>
          {items.map((step, index) => (
            <li key={index} className={classes.step}>
              <span className={classes.num}>{index + 1}</span>
              <span className={classes.stepText}>{step}</span>
            </li>
          ))}
        </ol>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{closeLabel || "Cerrar"}</Button>
        {onOpen ? (
          <Button color="primary" variant="contained" startIcon={<OpenInNewIcon />} onClick={onOpen}>
            {openLabel || "Abrir"}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default GuideFloat;
